/**
 * determines which school year a date belongs to.
 * @param {Number} date takes in a timestamp.
 * @returns {string} school year eg.. sy2xxx
 */
export default function determineSchoolYear(date){
    let createdDate = new Date(date)
  
      if(createdDate.getMonth() >= 6){
        return `sy${createdDate.getFullYear()}`
      } else {
        return `sy${createdDate.getFullYear() - 1}`
      }
  }


// WEBPACK FOOTER //
// ./src/helpers/determineSchoolYear.js